import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

function slugify(s) {
  return (s || "").toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 50);
}

export default function CreateTopicModal({ open, onClose, onCreated }) {
  const [title, setTitle] = useState("");
  const [topicId, setTopicId] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [manualId, setManualId] = useState(false);

  const effectiveId = manualId ? topicId : slugify(title);

  const submit = async (e) => {
    e.preventDefault();
    if (!title.trim()) { toast.error("Informe um título"); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/moderation/topics", {
        topic_id: effectiveId,
        title: title.trim(),
        subtitle,
        description,
      });
      toast.success("Tópico criado — agora edite para adicionar dicas, seções e imagens.");
      onCreated(data);
      setTitle(""); setTopicId(""); setSubtitle(""); setDescription(""); setManualId(false);
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="create-topic-modal" className="max-w-lg bg-white rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Novo tópico</DialogTitle>
          <DialogDescription className="text-brand-textMuted">
            Crie um novo guia informativo (ex: FODMAP, Alergia a Amendoim). Você poderá adicionar seções e dicas depois.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <label className="block text-sm font-bold text-brand-text mb-1">Título</label>
            <Input data-testid="new-topic-title" required value={title} onChange={(e) => setTitle(e.target.value)} placeholder="ex: FODMAP" className="bg-brand-bg border-brand-border rounded-2xl h-11" />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-bold text-brand-text">Identificador na URL</label>
              <button type="button" className="text-xs text-brand-primary font-bold" onClick={() => setManualId((v) => !v)}>
                {manualId ? "Gerar automático" : "Editar manualmente"}
              </button>
            </div>
            <Input data-testid="new-topic-id" value={effectiveId} disabled={!manualId} onChange={(e) => setTopicId(e.target.value)} placeholder="ex: fodmap" className="bg-brand-bg border-brand-border rounded-2xl h-11 font-mono" />
            <p className="text-xs text-brand-textMuted mt-1">A URL será <code>/topico/{effectiveId || "..."}</code></p>
          </div>
          <div>
            <label className="block text-sm font-bold text-brand-text mb-1">Subtítulo (opcional)</label>
            <Input data-testid="new-topic-subtitle" value={subtitle} onChange={(e) => setSubtitle(e.target.value)} className="bg-brand-bg border-brand-border rounded-2xl h-11" />
          </div>
          <div>
            <label className="block text-sm font-bold text-brand-text mb-1">Descrição inicial (opcional)</label>
            <Textarea data-testid="new-topic-description" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} className="bg-brand-bg border-brand-border rounded-2xl" />
          </div>
          <DialogFooter className="gap-2 pt-2">
            <Button type="button" variant="outline" onClick={onClose} className="rounded-full font-bold">Cancelar</Button>
            <Button type="submit" data-testid="new-topic-submit" disabled={saving} className="bg-brand-primary hover:bg-brand-primaryHover text-white rounded-full font-bold">
              {saving ? "Criando..." : "Criar tópico"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
